var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 21 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2A3029EC-4832-48B9-96E0-58504174D64A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Medium-3-Copy-17",
    transform: "translate(-980.000000, -4368.000000)",
    fill: "#17171B",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "instagram",
    transform: "translate(980.937159, 4368.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0098813,0 L5.00329378,0 C2.2517265,0 0,2.24926758 0,5 L0,15 C0,17.7497559 2.2517265,20 5.00329378,20 L15.0098813,20 C17.7614486,20 20.0131751,17.7497559 20.0131751,15 L20.0131751,5 C20.0131751,2.24926758 17.7614486,0 15.0098813,0 Z M10.0065876,14.1665039 C7.70355775,14.1665039 5.83709464,12.3004883 5.83709464,10 C5.83709464,7.69848633 7.70355775,5.83325195 10.0065876,5.83325195 C12.3085913,5.83325195 14.1760805,7.69848633 14.1760805,10 C14.1760805,12.3004883 12.3085913,14.1665039 10.0065876,14.1665039 Z M15.4269039,5.83325195 C14.7354331,5.83325195 14.1760805,5.27348633 14.1760805,4.58325195 C14.1760805,3.89301758 14.7354331,3.33325195 15.4269039,3.33325195 C16.1183747,3.33325195 16.6777274,3.89301758 16.6777274,4.58325195 C16.6777274,5.27348633 16.1183747,5.83325195 15.4269039,5.83325195 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.dbcbbf7ac6ab09e22924183436f7ae4e.svg";
export { ForwardRef as ReactComponent };